module.exports = __webpack_public_path__ + "static/media/analysis.23cb247d.svg";